import * as Factory from 'factory.ts'
import faker from 'faker'

import { type LegalEntityApiModel } from '../LegalEntityApiModel'

export const LegalEntityApiModelStub =
  Factory.Sync.makeFactory<LegalEntityApiModel>({
    id: Factory.each((i) => i + 1),
    uuid: Factory.each(() => faker.random.uuid()),
    name: Factory.each(() => faker.company.companyName()),
    base_currency: { id: 1, name: 'USD', rate: '1.000000' },
    country: Factory.each(() => faker.address.country()),
    external_id: null,
    active: true,
    created_at: '2026-06-01T12:00:00Z',
    updated_at: '2026-06-01T12:00:00Z',
    assigned_locations_count: 0,
    inbox_email_address: null,
  })
